import Vue from 'vue'

const sha1 = require('js-sha1')
const moment = require('moment')

const MWM_APPSTORE_DEV_API_ROOT = 'https://dev-dot-api-dot-mwm-appstore.appspot.com'
const MWM_APPSTORE_API_ROOT = 'https://api-dot-mwm-appstore.appspot.com'

export default {

  postAttribution (payload) {
    const authHeader = sha1(moment().utc().format().substring(0, 13) + 'MWM_Secure')
    let headers = {
      'MWM-AUTH': authHeader,
      'MWM-APP-KEY': payload.headers.appKey,
      'MWM-OFFER': payload.headers.offer,
      'MWM-APP-VERSION': payload.headers.version
    }
    let root = MWM_APPSTORE_API_ROOT
    if (payload.env === 'dev') { root = MWM_APPSTORE_DEV_API_ROOT }
    return Vue.http.post(root + '/attribution', payload.body, { headers: headers })
      .then((response) => Promise.resolve(response.body))
      .catch((error) => Promise.reject(error))
  }

}
